import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const RegisterPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      navigate('/register-error');
      return;
    }

    const validateToken = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_GAME_API_URL}/users/validateRequest`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-API-Key': process.env.REACT_APP_GAME_API_KEY || '',
          },
          body: JSON.stringify({ token: token.trim() }),
        });

        if (!response.ok) {
          throw new Error('Token invalid');
        }

        const result = await response.json();

        // Store the token + userId locally (pass to next page)
        sessionStorage.setItem('userToken', token);
        sessionStorage.setItem('userId', result.userId);
        sessionStorage.setItem('emailAddress', result.emailAddress)

        // Proceed to next step
        navigate('/update');
      } catch (err) {
        console.error('❌ Token validation failed:', err);
        navigate('/register-error');
      }
    };

    validateToken();
  }, [token, navigate]);

  return (
    <div style={{ color: 'var(--text-normal)', padding: '2rem' }}>
      <h1 style={{ color: 'var(--text-header)' }}>Validating...</h1>
    </div>
  );
};

export default RegisterPage;
